import { render, staticRenderFns } from "./CompaniesCreate.vue?vue&type=template&id=4893abb6&"
import script from "./CompaniesCreate.vue?vue&type=script&lang=js&"
export * from "./CompaniesCreate.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports